import { Outlet } from 'react-router-dom';

import { useHasUpgradeSSCAccess } from '../../hooks/ssc/use-has-upgrade-ssc-access/use-has-upgrade-ssc-access';

export const ScannerUpgradeScheduleGuard = () => {
  const hasUpgradeSSCAccess = useHasUpgradeSSCAccess();

  if (!hasUpgradeSSCAccess) {
    return;
  }

  return <Outlet />;
};
